export default "__VITE_ASSET__39dad3c0__"